import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";

export default createReactClass({
  displayName: "Root",
  propTypes: {
    banner: PropTypes.object.isRequired,
  },
  componentDidMount() {
    // ga('send', 'event', `${this.props.banner.gtag_imp_event_category_name}`, `${this.props.banner.gtag_imp_event_name}`, '/search');
  },
  onBannerClick() {
    // ga('send', 'event', `${this.props.banner.gtag_click_event_category_name}`, `${this.props.banner.gtag_click_event_name}`, '/search');
  },
  render() {
    return (
      <div className="text-center container col-md-8 col-lg-6 p-0">
        <a
          href={this.props.banner.link_url}
          target="_blank"
          onClick={this.onBannerClick}
          rel="noreferrer"
        >
          <img
            src={this.props.banner.banner_image_url}
            srcSet={this.props.banner.banner_image_url_medium_large}
            style={{ width: "100%" }}
          />
        </a>
      </div>
    );
  },
});
